import { FileDown } from "lucide-react";
import { API } from "../lib/api";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";

/**
 * A legal text from Ajustes (privacy policy, Aviso legal, Condiciones de
 * uso) in a scrollable dialog. The texts are plain text, so line breaks are
 * kept as written.
 */
export default function LegalDocumentDialog({ open, onOpenChange, title, version, text, testId, children }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid={testId}>
        <DialogHeader>
          <DialogTitle>
            {title}
            {version ? (
              <span className="text-xs font-normal text-gray-400 ml-2 font-mono-data">v{version}</span>
            ) : null}
          </DialogTitle>
        </DialogHeader>
        <div className="text-sm text-gray-700 leading-relaxed whitespace-pre-wrap">
          {text || "Cargando…"}
        </div>
        {children}
      </DialogContent>
    </Dialog>
  );
}

/** Condiciones de uso, with the withdrawal form download when there is one. */
export function TermsOfUseDialog({ open, onOpenChange, legal }) {
  return (
    <LegalDocumentDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Condiciones de uso"
      version={legal?.condiciones_version}
      text={legal?.condiciones}
      testId="terms-modal"
    >
      {legal?.has_withdrawal_form && (
        <div className="pt-4 border-t border-gray-100">
          <a
            href={`${API}/public/legal/withdrawal-form`}
            className="inline-flex items-center gap-2 text-sm font-medium text-brand-ink hover:text-brand"
            data-testid="withdrawal-form-download"
          >
            <FileDown className="w-4 h-4" />
            Descargar formulario de desistimiento (PDF)
          </a>
        </div>
      )}
    </LegalDocumentDialog>
  );
}
